import { render, staticRenderFns } from "./data2.vue?vue&type=template&id=c4a159ac"
import script from "./data2.vue?vue&type=script&lang=js"
export * from "./data2.vue?vue&type=script&lang=js"
import style0 from "./data2.vue?vue&type=style&index=0&id=c4a159ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports